import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { BuySharedFrequentlyAskedQuestionItem } from './BuySharedFrequentlyAskedQuestionItem';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { frequentlyAskedQuestions as frequentlyAskedQuestionsTitle } from '../buyMessages';

import styles from './BuySharedFrequentlyAskedQuestions.scss';

const BuySharedFrequentlyAskedQuestionsComponent = ({ buyPage: { frequentlyAskedQuestions } }) => {
    const [expandedItem, setExpandedItem] = useState(-1);
    const { isMobile } = useContext(ServerVarsContext);

    const Header = isMobile ? (
        <div className={styles.mobileHeader}>{frequentlyAskedQuestionsTitle}</div>
    ) : (
        <BarHeader title={frequentlyAskedQuestionsTitle} />
    );

    if (!frequentlyAskedQuestions || !frequentlyAskedQuestions.length) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            {Header}
            <div>
                {frequentlyAskedQuestions.map(({ question, answer }, index) => {
                    return (
                        <BuySharedFrequentlyAskedQuestionItem
                            key={question}
                            index={index}
                            question={question}
                            answer={answer}
                            isExpanded={index === expandedItem}
                            onClick={setExpandedItem}
                        />
                    );
                })}
            </div>
        </div>
    );
};

BuySharedFrequentlyAskedQuestionsComponent.propTypes = {
    buyPage: PropTypes.object.isRequired,
};

export const BuySharedFrequentlyAskedQuestions = createFragmentContainer(
    BuySharedFrequentlyAskedQuestionsComponent,
    {
        buyPage: graphql`
            fragment BuySharedFrequentlyAskedQuestions_buyPage on ItemSearchQueryConnection {
                frequentlyAskedQuestions {
                    question
                    answer
                }
            }
        `,
    }
);
